var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "client-profile-lists",
      "store-path": "clientProfileLists",
      "body-class": "client-profile-scroll-card pt-0 pb-3",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _vm._v("\n    " + _vm._s(_vm.$tc("lists.list", 2)) + "\n    "),
            !collapsed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row align-items-center right-inner-addon w-80 w-lg-auto",
                  },
                  [
                    _c("icon", {
                      attrs: { name: "search", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText,
                          expression: "searchText",
                        },
                      ],
                      staticClass: "form-control search-clients ignore-popover",
                      attrs: {
                        id: "search-lists",
                        type: "search",
                        placeholder: _vm.$t("tables.filters.searchFor", {
                          item: _vm.$tc("lists.list", 2),
                        }),
                        autocomplete: "off",
                        "data-lpignore": "true",
                      },
                      domProps: { value: _vm.searchText },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchText = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "d-none", attrs: { for: "search-lists" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("tables.filters.searchFor", {
                              item: _vm.$tc("lists.list", 2),
                            })
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("co-applicants-info-loader")
              : _vm.filteredLists.length > 0
              ? _vm._l(_vm.filteredLists, function (ref, index) {
                  var listId = ref.listId
                  var name = ref.name
                  var description = ref.description
                  var emailCount = ref.emailCount
                  var updatedAt = ref.updatedAt
                  var familyName = ref.familyName
                  var givenName = ref.givenName
                  var photoVersion = ref.photoVersion
                  var profilePhoto = ref.profilePhoto
                  var username = ref.username
                  return _c(
                    "div",
                    {
                      key: listId,
                      class: { "mb-3": index !== _vm.filteredLists.length - 1 },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.right",
                              value: {
                                title: _vm.isOwner(username)
                                  ? ""
                                  : _vm.$t("lists.messages.youAreNotOwner"),
                              },
                              expression:
                                "{\n            title: isOwner(username)\n              ? ''\n              : $t('lists.messages.youAreNotOwner')\n          }",
                              modifiers: { right: true },
                            },
                          ],
                          staticClass: "d-inline-block",
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-primary bold btn-view-app",
                              class: { disabled: !_vm.isOwner(username) },
                              attrs: { to: _vm.getSegmentLink(listId) },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "bold text-primary title-secondary mb-0",
                                  staticStyle: { "font-size": "1.14rem" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(name) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "\n          " + _vm._s(description) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _c("span", { staticClass: "bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm.$tc("global.words.email", 2)
                                )
                              ) +
                              ":\n          "
                          ),
                        ]),
                        _vm._v(
                          "\n          " + _vm._s(emailCount) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "mb-0" },
                        [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("global.actions.lastUpdate")) +
                                ": "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("refreshable-timeago", {
                            attrs: { date: updatedAt },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              {
                                staticClass: "client-avatar mr-2",
                                staticStyle: {
                                  width: "1.5rem",
                                  height: "1.5rem",
                                },
                              },
                              "profile-avatar",
                              {
                                familyName: familyName,
                                givenName: givenName,
                                photoVersion: photoVersion,
                                profilePhoto: profilePhoto,
                                username: username,
                              },
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(givenName) + " " + _vm._s(familyName)
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                })
              : _c(
                  "no-results",
                  {
                    attrs: {
                      "img-src": require("@Shared/assets/img/email.png"),
                      "img-class": "my-2",
                      "text-class": "regular text-light-gray",
                      "text-style": "",
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("lists.noListsToShow")) +
                        "\n    "
                    ),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }